import 'htmx.org'

const isMobileOrTablet = () => /(android|iphone|ipad|mobile)/i.test(navigator.userAgent)

const openSharePopup = (url: string) => window.open(url, 'sharer', 'toolbar=no,width=1042,height=436')

// Copy the campaign link and flash a confirmation, either in a dedicated
// message element (`data-copy-feedback`) or by swapping the trigger's own label.
function initCopyLinks() {
  document.querySelectorAll<HTMLElement>('[data-copy-link]').forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault()

      const value = trigger.dataset.copyLink
      if (value) navigator.clipboard?.writeText(value).catch(() => {})

      const duration = Number(trigger.dataset.copyFeedbackDuration || 1200)
      const messageId = trigger.dataset.copyFeedback
      const message = messageId ? document.getElementById(messageId) : null
      const copyLabel = trigger.querySelector<HTMLElement>('[data-copy-label]')
      const copiedLabel = trigger.querySelector<HTMLElement>('[data-copied-label]')

      if (message) message.hidden = false
      if (copyLabel) copyLabel.hidden = true
      if (copiedLabel) copiedLabel.hidden = false

      setTimeout(() => {
        if (message) message.hidden = true
        if (copyLabel) copyLabel.hidden = false
        if (copiedLabel) copiedLabel.hidden = true
      }, duration)
    })
  })
}

function initShareButtons() {
  document.querySelectorAll<HTMLElement>('[data-share-popup]').forEach((button) => {
    button.addEventListener('click', () => {
      const url = button.dataset.sharePopup
      if (url) openSharePopup(url)
    })
  })

  document.querySelectorAll<HTMLElement>('[data-share-whatsapp]').forEach((button) => {
    button.addEventListener('click', () => {
      const text = button.dataset.shareWhatsapp
      if (text) window.open(`https://${isMobileOrTablet() ? 'api' : 'web'}.whatsapp.com/send?text=${text}`)
    })
  })

  document.querySelectorAll<HTMLElement>('[data-share-messenger]').forEach((button) => {
    button.addEventListener('click', () => {
      if (isMobileOrTablet()) {
        const mobileUrl = button.dataset.mobileUrl
        if (mobileUrl) window.open(mobileUrl)
      } else {
        const desktopUrl = button.dataset.desktopUrl
        if (desktopUrl) openSharePopup(desktopUrl)
      }
    })
  })
}

// The shareable image is rendered on request, so only fetch it once the
// manager opens its modal.
function initShareableImage() {
  document.querySelectorAll<HTMLElement>('[data-load-shareable-image]').forEach((button) => {
    button.addEventListener('click', () => {
      const modalId = button.getAttribute('commandfor')
      const image = modalId
        ? document.getElementById(modalId)?.querySelector<HTMLImageElement>('[data-shareable-image]')
        : null
      if (!image?.dataset.src || image.getAttribute('src')) return

      const spinner = image.parentElement?.querySelector('[data-shareable-image-spinner]')
      const hideSpinner = () => spinner?.classList.add('hidden')
      image.addEventListener('load', hideSpinner, { once: true })
      image.addEventListener('error', hideSpinner, { once: true })
      image.src = image.dataset.src
    })
  })
}

function initCampaignManagePage() {
  const navSelect = document.getElementById('manage-nav-select')

  navSelect?.addEventListener('change', (event) => {
    const path = (event.target as HTMLSelectElement).value
    if (path) window.location.href = path
  })

  initCopyLinks()
  initShareButtons()
  initShareableImage()
}

document.addEventListener('DOMContentLoaded', initCampaignManagePage)
document.addEventListener('htmx:afterSwap', (event) => {
  if ((event as CustomEvent).detail.target === document.body) {
    initCampaignManagePage()
  }
})
